function state() {
  return {
    banks: [],
    bank: {},
    isValidAccountNumber: {},
  };
}

export default state;
